import { Stack, Typography } from '@mui/material'
import { KomejirushiMongon } from '~/components/common/KomejirushiMongon'
import { FC } from 'react'
import { LinkToInfo } from '~/components/common/LinkToInfo'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'

export const SecondStep: FC = () => {
  return (
    <Stack spacing={0.5}>
      <KomejirushiMongon
        sx={{ mb: 2 }}
        text="既にInstagramアカウントをお持ちの方は、「次のステップへ」からお進みください。"
      />
      <Typography>
        広告したい店舗やサービスのInstagramアカウントをお持ちでない方は、Instagramアカウントを作成してください。
      </Typography>
      <LinkToInfo
        href={EXTERNAL_LINKS.INSTAGRAM_ACCOUNT_CREATION}
        textBefore=""
        linkText="Instagramアカウントの作成"
      />
    </Stack>
  )
}
